import angular from 'angular';
import { ReportsComponent } from './reports.component';
import ReportsLister from './../reports-lister.module';
import ReportsList from './../reports-list/reports-list.module';

export const ReportsModule = angular
	.module('reports', [ReportsLister, ReportsList])
	.component('reports', ReportsComponent)
	.name;
